// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__Wgs6w","colCheckbox":"styles_colCheckbox__3MtIk"};